module.exports = __webpack_public_path__ + "static/img/6699_phase_function_Paper_PointsHejduk_Prediction.63cdaac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6699_phase_function_Paper_PointsHejduk_Prediction.png
// module id = n/Fw
// module chunks = 0